// extracted by mini-css-extract-plugin
export var actionButton = "_fl-t";
export var buttonContainer = "_fl-0";
export var buttonContainer2 = "_fl-1";
export var buttonSection = "_fl-2";
export var details = "_fl-3";
export var dropdownItem = "_fl-5";
export var dropdownItemsContainer = "_fl-4";
export var fileInput = "_fl-r";
export var headerButton = "_fl-6";
export var icon = "_fl-7";
export var input = "_fl-8";
export var macroListItem = "_fl-9";
export var mainContent = "_fl-a";
export var microText = "_fl-b";
export var modal = "_fl-w";
export var optionsButton = "_fl-c";
export var paperclip = "_fl-s";
export var pillContent = "_fl-d";
export var preview = "_fl-e";
export var preview2 = "_fl-f";
export var quillEditor = "_fl-q";
export var selectedMacro = "_fl-g";
export var sidebar = "_fl-h";
export var sidebarHeader = "_fl-j";
export var sidebarList = "_fl-i";
export var sidebarListItem = "_fl-k";
export var sidebarSearch = "_fl-l";
export var snoozeDurationWrapper = "_fl-v";
export var statusPillContainer = "_fl-m";
export var tagsContainer = "_fl-n";
export var unselectedMacro = "_fl-o";
export var variable = "_fl-u";
export var wrapper = "_fl-p";